import { ExportFileMenuItem } from "./ExportButtons.styles.ts";
import { AcknowledgmentEmailFormat, AcknowledgmentEmailFormatType } from "../../types/declarations/enums.ts";
import { exportPDFCondensedText, exportPDFExpandedText, exportPDFText } from "../../constants/text.ts";

interface ExportButtonsMenuItemsProps {
	isAcknowledgements: boolean;
	isMerchOrder: boolean;
	onPdfSelect: (format?: AcknowledgmentEmailFormatType) => void;
}

const ExportButtonsMenuItems = ({ isAcknowledgements, isMerchOrder, onPdfSelect }: ExportButtonsMenuItemsProps) => {
	if (isAcknowledgements) {
		return (
			<>
				{!isMerchOrder && (
					<ExportFileMenuItem
						onClick={() => onPdfSelect(AcknowledgmentEmailFormat.EXPANDED)}
						data-testid="order-list-export-expanded-pdf"
					>
						{exportPDFExpandedText}
					</ExportFileMenuItem>
				)}

				<ExportFileMenuItem
					onClick={() => onPdfSelect(AcknowledgmentEmailFormat.CONDENSED)}
					data-testid="order-list-export-condensed-pdf"
				>
					{exportPDFCondensedText}
				</ExportFileMenuItem>
			</>
		);
	}

	return (
		<ExportFileMenuItem
			onClick={() => onPdfSelect()}
			data-testid="order-list-export-pdf"
		>
			{exportPDFText}
		</ExportFileMenuItem>
	);
};

export default ExportButtonsMenuItems;
